import { render, staticRenderFns } from "./OtherSupport.vue?vue&type=template&id=1952ecbb&"
import script from "./OtherSupport.vue?vue&type=script&lang=js&"
export * from "./OtherSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports